<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <p>添加水印</p>
                <img @click="close" src="../../assets/img/common/editPicClose.svg" alt="">
            </div>
            <div class="content">
                <div class="left-container">
                    <p class="t">水印选择：</p>
                    <ul class="list">
                        <li @click="selectIndex = index" v-for="(item, index) in list" :key="index">
                            <i :class="{on: selectIndex == index}"></i>
                            <span>{{item.logo_title}}</span>
                        </li>
                    </ul>
                </div>
                <div class="right-container">
                    <p class="t">水印预览：</p>
                    <div class="img" :style="'background-image: url('+logoImg+')'"></div>
                    <!-- <img :src="" alt=""> -->
                </div>
            </div>
            <div class="btn-container">
                <div @click="confirm" class="btn g">确定</div>
                <div @click="close" class="btn">取消</div>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "@common/common";
    import { apis } from "@common/config";
    import vClickOutside from "v-click-outside";

    export default {
        directives: {
            clickOutside: vClickOutside.directive
        },
        data() {
            return {
                videoInfo: '',
                selectIndex: 0,
                show: true,
                showType: false,
                list: [],
                selectList: [],
                typeSelectList: [{
                    isSelect: false,
                    column_title: '视频稿'
                },{
                    isSelect: false,
                    column_title: '图文稿'
                }],
                c: null,
                platformIndex: 0,
                columnIndex: 0,
                id: '',
                showThird: true,
                logoImg: '',
                selectPlatform: ''
            }
        },
        watch: {
            selectIndex(to) {
                this.logoImg = this.list[to].code
            }
        },
        methods: {
            open(res, c, videoInfo, selectPlatform) {
                // console.log(res)
                let hasSelect = false
                if(videoInfo){
                    this.videoInfo = videoInfo

                    if(selectPlatform == 'five_star_sports_cms' && res && res.length > 0){
                        res.forEach((el,index) => {
                            if(!hasSelect && el.display_ratio == videoInfo){
                                hasSelect = true;
                                this.selectIndex = index
                            }
                        });
                    }
                }
                this.list = res
                this.c = c;
                this.show = true;
                this.logoImg = res[0].code
                this.selectPlatform = selectPlatform
            },
            close() {
                this.show = false;
                this.c(99999)
            },
            confirm() {
                if(this.videoInfo == this.list[this.selectIndex].display_ratio){
                    this.show = false;
                    this.c(this.selectIndex)
                }else if(this.selectPlatform == 'dy'){
                    this.show = false;
                    this.c(this.selectIndex)
                }else{
                    let config = {
                        title: '温馨提示',
                        content: '当前已选水印为<em>'+this.list[this.selectIndex].logo_title+'</em>，分辨率与原视频不一致，是否确定？',
                        btn1: '确定',
                        btn2: '我再想想',
                        showIcon: true
                    }
                    this.$MediaPlatformNotify(config).then(res => {
                        if(res){
                            this.show = false;
                            this.c(this.selectIndex)
                        }
                    })
                }
                // this.show = false;
                // this.c(this.selectIndex)
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000002;

    .box-container {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        width: 774px;
        height: 432px;
        padding: 20px 30px 24px;
        background: #F9F9F9;
        border-radius: 4px;
        box-sizing: border-box;

        &>.title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            p {
                font-size: 24px;
                color: #323B4B;
                line-height: 33px;
                font-weight: bold;
            }
        }

        .content {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            height: 247px;
            margin-bottom: 56px;

            .left-container {
                display: flex;
                flex-direction: column;
                width: 323px;
                height: 100%;
                margin-right: 50px;

                .t {
                    font-size: 14px;
                    color: #323B4B;
                    font-weight: bold;
                    margin-bottom: 20px;
                }

                .list {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    min-height: 0;
                    overflow-y: auto;
                    width: 100%;

                    /*滚动条样式*/
                    &::-webkit-scrollbar {/*滚动条整体样式*/
                        width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
                        height: 2px;
                    }
                    &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                        border-radius: 5px;
                        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        background: rgba(0,0,0,0.1);
                    }
                    &::-webkit-scrollbar-track {/*滚动条里面轨道*/
                        // box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        border-radius: 0;
                        background: transparent;
                    }

                    li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        padding-left: 20px;
                        box-sizing: border-box;
                        width: 100%;
                        min-height: 18px;
                        overflow: hidden;
                        margin-bottom: 19px;
                        user-select: none;
                        cursor: pointer;

                        i {
                            position: relative;
                            display: block;
                            width: 16px;
                            height: 16px;
                            background: rgba(130, 145, 145, 0.15);
                            border-radius: 8px;
                            margin-right: 8px;

                            &.on {
                                background: #41B48C;
                                &:after {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%,-50%);
                                    display: block;
                                    content: '';
                                    width: 6px;
                                    height: 6px;
                                    background: #FFFFFF;
                                    border-radius: 20px;
                                }
                            }
                        }

                        span {
                            font-size: 13px;
                            color: rgba(50, 59, 75, 1)
                        }
                    }
                }
            }

            .right-container {
                flex: 1;
                min-width: 0;
                height: 100%;

                .t {
                    font-size: 14px;
                    color: #323B4B;
                    font-weight: bold;
                    margin-bottom: 20px;
                }

                .img {
                    width: 319px;
                    height: 180px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    border-radius: 4px;
                }
            }
        }

        .btn-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;

            .btn {
                width: 120px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #B9C3C3;
                border-radius: 4px;
                font-size: 14px;
                color: #FFFFFF;
                user-select: none;
                cursor: pointer;

                &.g {
                    background: #41B48C;
                    margin-right: 20px
                }
            }
        }
    }
}
</style>